import React from 'react';
import 'assets/css/KPIElement.css';

const KPIElement = ({ title, value, unit }) => {
    return (
        <div className="kpi-container">
            <div className="kpi-title">{title}</div>
            <div>
                <span className="kpi-value">{value}</span>
                {unit && <span className="kpi-unit">{unit}</span>}
            </div>
        </div>
    );
};

export default KPIElement;
